import React, {useRef, useState} from 'react';
import cl from "../BaseSimplePage/BaseSimpleItemBrowserHeader.module.css";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, useTheme} from "@mui/material";
import RefreshIcon from "../../components/Icons/RefreshIcon";
import FormInput from "../../formComponents/FormInput";
import SearchIcon from "../../components/Icons/SearchIcon";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const LOCALE_TEXT = {
    fieldDayPlaceholder: (params) => 'ДД',
    fieldMonthPlaceholder: (params) => params.contentType === 'digit' ? 'ММ' : params.format,
    fieldYearPlaceholder: (params) => 'ГГГГ',
}

const SurveysItemBrowserHeader = ({
                                        totalItemCount,
                                        onFilterEdit,
                                        renderExtraContent,
                                        onSearchById,
                                        dateFromText,
                                        setDateFromText,
                                        dateTillText,
                                        setDateTillText,
                                    }) => {

    const [byIdSearchDialogIsOpen, setByIdSearchDialogIsOpen] = useState(false);
    const controlRefSearchId = useRef(null);

    const [dateFromValue, setDateFromValue] = useState(dateTextToDayJs(dateFromText))
    const [dateTillValue, setDateTillValue] = useState(dateTextToDayJs(dateTillText))

    const theme = useTheme();

    function handleClose() {
        setByIdSearchDialogIsOpen(false);
    }

    function onByIdSearchDialogSearchBtnClick() {
        const idText = controlRefSearchId.current.getText();
        if (idText === "") {
            controlRefSearchId.current.setErrorMessage("Нужно указать ID!");
            return;
        }

        const regex = /^\d+$/
        const id = parseInt(idText);
        if (idText.length > 9 || !regex.test(idText) || isNaN(id) || id <= 0) {
            controlRefSearchId.current.setErrorMessage("Неверно указан ID!");
            return;
        }

        setByIdSearchDialogIsOpen(false);
        onSearchById(id);
    }

    function renderDatePicker(label, dateValue, setDateValue, setDateText) {
        return <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ru"
            localeText={LOCALE_TEXT}
        >
            <DatePicker
                value={dateValue}
                label={label}
                slotProps={{
                    field: {
                        clearable: true,
                        size: "small"
                    },
                }}
                disableHighlightToday
                onChange={(v,c) => {
                    //console.log("onChange", "v=", v, "c=", c);
                    //console.log("date=", v?.format('YYYY-MM-DD') ?? "null")
                    setDateValue(v);
                    setDateText(c.validationError ? "error" : dayJsToDateText(v))
                    onFilterEdit();
                }}
                sx={{backgroundColor: 'white'}}
            />
        </LocalizationProvider>
    }

    return (
        <div className={cl.main}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                /*backgroundColor: "#0000ff40",*/
                marginBottom: "10px",
                flexWrap: "wrap",
                rowGap: "7px",
                columnGap: "12px",
            }}>
                <p style={{
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#222',
                    textWrap: "nowrap",
                }}>
                    {totalItemCount >= 0 && <>Найдено: {totalItemCount}</>}
                </p>
                <div style={{display: "flex", gap: "10px", /*backgroundColor: "#00ff0040"*/}}>
                    <Tooltip title={<div className={cl.tip}>Обновить</div>}>
                        <Button
                            variant="outlined"
                            size="medium"
                            sx={{width: "40px", minWidth: "40px"}}
                            onClick={() => onFilterEdit(true)}
                        >
                            <RefreshIcon fgColor={"rgba(0, 0, 0, 0.54)"}/>
                        </Button>
                    </Tooltip>
                    <Tooltip title={<div className={cl.tip}>Поиск по ID</div>}>
                        <Button
                            variant="outlined"
                            size="medium"
                            sx={{width: "40px", minWidth: "40px"}}
                            onClick={() => setByIdSearchDialogIsOpen(true)}
                        >
                            <div style={{position: "absolute", display: "flex"}}>
                                <SearchIcon fgColor={"rgba(0, 0, 0, 0.54)"}/>
                                <span style={{
                                    fontSize: "10px",
                                    position: "absolute",
                                    right: "-3px",
                                    bottom: "7px"
                                }}>ID</span>
                            </div>
                        </Button>
                    </Tooltip>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                {renderDatePicker("Даты с", dateFromValue, setDateFromValue, setDateFromText)}
                {renderDatePicker("Даты по", dateTillValue, setDateTillValue, setDateTillText)}
            </div>
            {renderExtraContent && renderExtraContent()}
            <Dialog open={byIdSearchDialogIsOpen} onClose={handleClose} maxWidth={"xs"}>
                <DialogTitle>Поиск записи по ID</DialogTitle>
                <DialogContent>
                    <FormInput
                        controlRef={controlRefSearchId}
                        label={"ID"}
                        widthLimit={150}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Отмена</Button>
                    <Button variant="outlined" onClick={onByIdSearchDialogSearchBtnClick}>Найти</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

function dateTextToDayJs(dateText) {
    return dateText && dateText !== "error" ? dayjs(dateText) : null;
}

function dayJsToDateText(value) {
    return value ? value?.format('YYYY-MM-DD') : "";
}

export default SurveysItemBrowserHeader;